import { DatabaseModel, ModelJson } from './database-model';
import { Coords } from './coords';
import { Media } from './media';
import { ChallengeStateMap } from '../models/challenge-state';

export enum GroupMemberState {
    IDLE = 'IDLE',
    WAITING = 'WAITING',
    READY = 'READY',
    ACTIVE = 'ACTIVE',
    COMPLETING = 'COMPLETING'
}

export class GroupMember extends DatabaseModel {
    /** User key */
    public key: string;
    /** User name */
    public userName: string = '';
    /** Profile picture for the group member */
    public profilePic: Media = null;
    /** The group member's state: IDLE, WAITING, READY or ACTIVE */
    public state: GroupMemberState = GroupMemberState.IDLE;
    /** The group member's `ChallengeStateMap` – keeping track of state (e.g. points) for multiple challenges/quizzes */
    public challengeStateMap: ChallengeStateMap = new ChallengeStateMap({});
    /** Coordinates for the group member */
    public coords: Coords = new Coords(0, 0, false);

    constructor(json?: ModelJson, key?: string) {
        super();
        if(json) this.fromJson(json);
        // Overwrite key from json if key is given in constructor, other wise use current key or gen a new
        this.key = (key) ? key : this.key || DatabaseModel.genKey();
    }

    public copy(): GroupMember {
        const currentMemberJson = JSON.stringify(this.toJson());
        return new GroupMember(JSON.parse(currentMemberJson));
    }

    public toJson(): ModelJson {
        return {
            key: this.key,
            userName: this.userName,
            profilePic: this.profilePic?.toJson() || null,
            state: this.state,
            challengeStateMap: this.challengeStateMap.toJson(),
            coords: this.coords.toJson()
        };
    }

    public fromJson(json: any) {
        this.key = json.key;
        this.userName = json.userName;
        this.profilePic = new Media(json.profilePic);
        this.state = json.state || GroupMemberState.IDLE;
        this.challengeStateMap = new ChallengeStateMap(json.challengeStateMap ? json.challengeStateMap : {});
        this.coords = Coords.fromJson(json.coords);
    }
}
